<template>
  <!--  v-bind:class="divisaoQuadroAtualLoop.configs.divisaoTelaCheia ? 'pa-0' : 'pa-2'"-->
  <div
      style="width: 100%; height: 100%;"
      :style="divisaoQuadroAtualLoop.configs.divisaoStyle"
      class="pa-0 ma-0"
  >
<!--    <div class="red&#45;&#45;text">-->
<!--      {{divisaoQuadroAtualLoop.configs.meioElementos}}-->
<!--    </div>-->
    <vue-draggable-resizable
        v-for="(el, i) in divisaoQuadroAtualLoop.configs.meioElementos"
        :key="i"
        :parent="true"

        :minWidth="25"
        :minHeight="25"

        :w=getRect(el).w
        :h=getRect(el).h
        :x=getRect(el).x
        :y=getRect(el).y
        :z="parseInt(el.draggable.zIndex)"

        @resizing="function (x, y, w, h) { onResize(i, x, y, w, h) }"
        @dragging="function (x, y) { onDrag(i, x, y) }"

        :style="exibindoEm == 'player' ? 'border: 0px;' : ''"
    >

      <!--        style="border: 4px solid !important; border-bottom-color: blue !important; border-left-color: violet !important; border-top-color: #eed200 !important; border-right-color: green !important;"-->

<!--          :class="cpMeioClass(i)"-->
      <div
          :class="cpMeioClass(i)"
          style="width: 100%; height: 100%;"
      >
        <div
            v-if="el.tipo == 'mercadoria'"
            :style="{
              ...{
              fontSize: `${getRect(el).h}px`,
              lineHeight: `${getRect(el).h}px`,
            },
            ...el.style
            }"
        >
          <span v-if="el.mercOptions.exibirCodigo">
            {{ el.mercDataAux.codigo }}
            &nbsp;
          </span>
          <span>
            {{ el.mercDataAux.descricao }}
          </span>
          <span v-if="el.mercOptions.exibirPreco">
            R${{ formataPrecoPlayer(el.mercDataAux.preco) }}
          </span>
        </div>
        <TabelaPreco
            v-if="el.tipo == 'tabela-preco'"
            style="width: 100%; height: 100%; overflow-y: scroll;"
            :elemento=el
            :height="getRect(el).h"
            :indice-quadro="divisaoQuadroAtualLoop.quadroIndex"
            :numero-divisao="divisaoQuadroAtualLoop.divisaoNumero"
            :current-slide-index="currentSlideIndex"
            :indice-elemento="i"
        ></TabelaPreco>
        <div
            v-if="el.tipo == 'texto'"
            :style="{
              ...{
              fontSize: `${getRect(el).h}px`,
              lineHeight: `${getRect(el).h}px`,
            },
            ...el.style
            }"
        >
          {{ el.conteudo }}
        </div>
        <v-img v-if="el.tipo == 'imagem' && !isVideo(el.conteudo)"
               :src="`/${$store.state.serverImgUserPath}/${el.conteudo}`"
               height="100%"
               width="100%"
        ></v-img>

          <video
              v-if="el.tipo == 'imagem' && isVideo(el.conteudo)"
              playsinline autoplay muted loop
              height="100%"
              width="100%"
          >
              <source :src="`/${$store.state.serverImgUserPath}/${el.conteudo}`" type='video/mp4'>
          </video>

        <!-- redireciona p outra pagina-->
<!--        <meta-->
<!--            v-if="el.tipo == 'link' && $store.state.modoExibicaoSlides == 'player'"-->
<!--            http-equiv="refresh"-->
<!--            :content="`1; URL='${el.conteudo}'`"-->
<!--        />-->
<!--        <span v-if="el.tipo == 'link' && $store.state.modoExibicaoSlides == 'edicao'">-->
<!--          O player vai redirecionar para {{el.conteudo}}-->
<!--        </span>-->

      </div>
    </vue-draggable-resizable>
  </div>

</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable';
import {timelineMixin} from "../timelineMixin.js";
import TabelaPreco from "@/views/timeline/components/TabelaPreco";
import {isVideo} from '../../../libs/utils';


export default {
  name: "Cartaz",
  components: {TabelaPreco},
  props: {
    divisaoQuadroAtualLoop: {
      type: [Object, Boolean],
      required: false
    },
  },
  mixins: [timelineMixin],
  data() {
    return {
      meioElementosLocal: [],
      configs: {},

      nome: "",
      loading: false,

      elementoMercData: [],
    }
  },
  computed: {
    cpMeioClass: (app) => (i) => {
      let elementos = app.divisaoQuadroAtualLoop.configs.meioElementos;
      let aClass = [];

      if (elementos[i]) {
        for (const k in elementos[i].class) {
          if (k != 'estilo') {
            aClass.push(elementos[i].class[k]);
          }
        }

        aClass.push(elementos[i].class.estilo);

        return aClass;
      }

      return null;
    },

    // cpViewBox: (app) => (i) => {
    //   let els = app.divisaoQuadroAtualLoop.configs.meioElementos;
    //
    //   if (els[i]) {
    //     return '0 0 100% 100%';
    //   }
    //
    //   return null;
    // },
  },

  created() {
    this.loadAllMercsInfos();
  },

  mounted() {
    this.$nextTick(() => {
      // this.elsMeioPerc2Px();
    })

  },

  methods: {
      isVideo(fileName){
          // de utils.js
          return isVideo(fileName);
      },

    getRect(el) {
      let w;
      let h;
      let x;
      let y;

      if (this.exibindoEm == 'areaEdicao') {
        w = (el.draggable.w);
        h = (el.draggable.h);
        x = (el.draggable.x);
        y = (el.draggable.y);
      }

      //calc percentual
      if (this.exibindoEm == 'player') {
        w = (el.draggable.wPerc);
        h = (el.draggable.hPerc);
        x = (el.draggable.xPerc);
        y = (el.draggable.yPerc);

        w = w * this.$store.state.timelineMainContainerSize.w;
        h = h * this.$store.state.timelineMainContainerSize.h;
        x = x * this.$store.state.timelineMainContainerSize.w;
        y = y * this.$store.state.timelineMainContainerSize.h;
      }
      //<!--endregion-->

      let rect = {
        w: w,
        h: h,
        x: x,
        y: y
      };

      return rect;
    },

    onDrag(elementoIndex, x, y) {
      let xPerc = (x / this.$store.state.timelineMainContainerSize.w)/* * 100*/;
      let yPerc = (y / this.$store.state.timelineMainContainerSize.h)/* * 100*/;

      let el = this.$store.getters.getMeioElementosDaDivisao[elementoIndex];

      el.draggable.x = x;
      el.draggable.y = y;

      el.draggable.xPerc = xPerc;
      el.draggable.yPerc = yPerc;

      this.$store.commit('setMeioElementoConfigsByIndex', {el: el, index: elementoIndex});
    },

    onResize(elementoIndex, x, y, w, h) {
      let xPerc = (x / this.$store.state.timelineMainContainerSize.w)/* * 100*/;
      let yPerc = (y / this.$store.state.timelineMainContainerSize.h)/* * 100*/;
      let wPerc = (w / this.$store.state.timelineMainContainerSize.w)/* * 100*/;
      let hPerc = (h / this.$store.state.timelineMainContainerSize.h)/* * 100*/;

      let el = this.$store.getters.getMeioElementosDaDivisao[elementoIndex];

      el.draggable.x = x;
      el.draggable.y = y;
      el.draggable.w = w;
      el.draggable.h = h;

      el.draggable.xPerc = xPerc;
      el.draggable.yPerc = yPerc;
      el.draggable.wPerc = wPerc;
      el.draggable.hPerc = hPerc;

      this.$store.commit('setMeioElementoConfigsByIndex', {el: el, index: elementoIndex});
    },

    // elsMeioPerc2Px() {
    //   this.$nextTick(function () {
    //     if (this.exibindoEm == 'areaEdicao') {
    //       return false;
    //     }
    //
    //     let els = this.divisaoQuadroAtualLoop.configs.meioElementos;
    //
    //     for (const i in els) {
    //       let rect = this.getRect(els[i]);
    //
    //       els[i].draggable.w = rect.w;
    //       els[i].draggable.h = rect.h;
    //       els[i].draggable.x = rect.x;
    //       els[i].draggable.y = rect.y;
    //     }
    //   })
    // },

    // getPrecoMerc(el) {
    //   if (typeof el.mercDataAux.mercadoriaFilial[0] == 'undefined') {
    //     return 'sem preço';
    //   }
    //
    //   return el.mercDataAux.mercadoriaFilial[0].preco;
    // },

    // getContainerHeightPx() {
    //   this.$nextTick(() => {
    //     this.containerHeightPx = this.$refs.container.clientHeight + 'px';
    //   });
    //   // Vue.set(this.leftColStyles, 'height', heightString);
    // },

    loadAllMercsInfos() {
      let els = this.divisaoQuadroAtualLoop.configs.meioElementos;

      for (let k in this.divisaoQuadroAtualLoop.configs.meioElementos) {
        this.meioElementosLocal[k] = this.divisaoQuadroAtualLoop.configs.meioElementos[k];
        if (els[k].tipo == "mercadoria") {
          this.getElementoMercadoria(els[k].conteudo, k);
        }
      }
    },

    getElementoMercadoria(id, k) {
      if (!id) {
        return false;
      }

      if (this.$store.state.modoExibicaoSlides == 'edicao') {
        axios.get(
            '/mercadorias/' +
            id,
            {params: []}
        ).then((response) => {
          this.loading = false;
          let resp = response.data;

          resp.preco = 'X,XX';

          this.meioElementosLocal[k].mercDataAux = Object.assign({}, resp);
        }, (error) => {
          console.log(error);
        }).catch(error => {
          console.log(error);
        }).finally(() => this.loading = false);
      } else if (this.$store.state.modoExibicaoSlides == 'player') {
        // axios.get(
        //     '/show-my-slides/' +
        //     this.$route.params.uid +
        //     '/mercadorias/' +
        //     id,
        //     {params: []}
        // ).then((response) => {
        //   this.loading = false;
        //   let resp = response.data;
        //
        //   this.meioElementosLocal[k].mercDataAux = Object.assign({}, resp);
        // }, (error) => {
        //   console.log(error);
        // }).catch(error => {
        //   console.log(error);
        // }).finally(() => this.loading = false);
      }
    },
  },

}
</script>

<style>
.handle {
  /*background-color: transparent !important;*/
  /*border-width: 0px !important;*/
}

/*.handle.handle-tm {*/
/*  width: 100% !important;*/
/*  left: 5px !important;*/
/*}*/
/*.handle.handle-bm {*/
/*  width: 100% !important;*/
/*  left: 5px !important;*/
/*}*/
/*.handle.handle-mr {*/
/*  height: 100% !important;*/
/*  top: 5px !important;*/
/*}*/
/*.handle.handle-ml {*/
/*  height: 100% !important;*/
/*  top: 5px !important;*/
/*}*/
</style>
